function initMap() {
    const mapElement = document.getElementById("map");

    if (mapElement) {
        
        const coords = [3.253490, 50.863200];

        let map = new mapboxgl.Map({
            container: mapElement,
            style: "mapbox://styles/mapbox/light-v10",
            center: coords,
            zoom: 10.0
        });

        map.on("load", () => {
            map.loadImage("/img/icon-maps-marker.png", (error, image) => {
                if (error) throw error;
                map.addImage("star-logo", image);
                map.addLayer({
                        id: "markers",
                        type: "symbol",
                        source: {
                            type: "geojson",
                            data: {
                                type: "FeatureCollection",
                                features: [{ 
                                    "type": "Feature", 
                                    "geometry": { 
                                        "type": "Point", 
                                        "coordinates": coords 
                                    } 
                                }]
                            }
                        },
                        layout: {
                            "icon-image": "star-logo",
                            "icon-size": 0.5
                        }
                });
            });
        });

        map.addControl(new mapboxgl.NavigationControl());
        map.scrollZoom.disable();
    }
}

export default function() {
    initMap();
}
